import React from 'react';

export const pageMeta = {
  "name": "JS Functions",
  "link": "/javascript/functions"
};

export default function JavascriptFunctions() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Functions</h2>
      <p>Route: /javascript/functions</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
